import Axios from 'axios';
const auth = JSON.parse(localStorage.getItem('auth')) || null;
const baseURL = 'https://mng-api.supercellnetwork.com/';
// const baseURL = 'https://mng-dev-api.supercellnetwork.com/';
// const baseURL = 'http://localhost:5005/';
export const $http = Axios.create({
  baseURL,
  timeout: 10000000,
  headers: {
    'X-Custom-Header': 'foobar',
    'Access-Control-Allow-Origin': 'http://localhost:3000',
    Authorization: `Bearer ${localStorage.getItem('token')}`
  }
});
